'use client'

import React, { FunctionComponent } from 'react'
import classNames from 'classnames'
import styles from './Header.module.css'
import { Props } from './Header.types'
import { MAIN_NAV } from '@/config/navigation.config'
import TicketsButton from '@/app/_components/TicketButton/TicketsButton'
import TXT from '@/messages'

export const Header: FunctionComponent<Props> = ({ portals, cityName }: Props) => (
  <>
    <nav className={styles.Header} id="header" role="navigation" aria-label="header-navigation">
      <a suppressHydrationWarning className={classNames(styles.Col)} aria-label={TXT.mw} href="https://meowwolf.com">
        <svg
          className={classNames(
            styles.LogoDesktop,
          )}
          height="40px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 331 40"
        >
          <defs />
          <path className={styles.Pink} d="M2 .9L19.4 13 36.8 1v35H2.1z" />
          <path className={styles.Blue} d="M69.1 1.1v10.6H62v2.7h7.1v8.5H62v2.7h7.1v10.2H40.2V1z" />
          <path className={styles.Yellow} d="M109.3 18.6A18.6 18.6 0 1 1 90.8 0c11.6 0 18.5 8.3 18.5 18.6z" />
          <path className={styles.Green} d="M168.4 1.1l-22 36c-4.2-7-8.3-12.7-12.5-19.7l-2.3 1.8 3.8 6.5-7.3 11.4-22-36z" />
          <path className={styles.Pink} d="M235 1.1l-22 36c-4.1-7-8.3-12.7-12.4-19.7l-2.4 1.9 3.6 6-7 11.9-22-36z" />
          <path className={styles.Yellow} d="M268.3 18.6A18.6 18.6 0 1 1 249.7 0a18.6 18.6 0 0 1 18.6 18.6z" />
          <path className={styles.Blue} d="M298.7 18.4v17.4h-27.2V1h17.7v17.3z" />
          <path className={styles.Green} d="M331 1.1V12h-7.1v2.7h7.1v10.9h-7.8v10.2H302V1z" />
        </svg>
        <svg
          className={classNames(
            styles.LogoMobile,
          )}
          height="30px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 82.9 99.5"
        >
          <g>
            <g stroke="#262a82" strokeMiterlimit="10" strokeWidth=".5">
              <path
                d="M7.7 50.3c1.4 0 4-1.2 5.8-2.8 2.5-2.2 6-5.2 11.6-5.2s9 3 11.5 5.1c1.8 1.6 3 2.7 4.7 2.7 1.8 0 3.4-1.3 5.5-3 2.6-2.1 5.9-4.8 10.6-4.8s7.7 2.6 10.2 4.7c2 1.8 3.8 3.3 6 3.6a9.5 9.5 0 0 0 7-1.8 7.8 7.8 0 0 0 2-2.5L53 .8a1.2 1.2 0 0 0-2.1 0l-7.8 12.5a1.3 1.3 0 0 0 0 1.4l5 7.3a1.3 1.3 0 0 1-.3 1.7l-1 .8a1.2 1.2 0 0 1-1.8-.3l-5-6.9L28.1 1a1.2 1.2 0 0 0-2 .1S0 45.5.1 47c.2.5 2.9 3.3 7.5 3.3z"
                fill="#ec0089"
              />
              <path
                d="M80.8 55a13.7 13.7 0 0 1-4 1.4 13.4 13.4 0 0 1-10.4-2.6l-2.8-2.5c-2.1-1.8-3.8-3.2-6.2-3.2s-4.5 1.6-6.7 3.5c-2.6 2-5.4 4.4-9.4 4.4s-6.5-2.3-8.8-4.3-4.1-3.6-7.4-3.6-5.3 1.7-7.6 3.7c-2.5 2.2-5.4 5-10.4 4.4A15.4 15.4 0 0 1 2.7 55a.8.8 0 0 0-1 1.2l2.7 4L29.7 99a.8.8 0 0 0 1.4 0l8.3-13.2a.8.8 0 0 0 0-1L34.1 77a.8.8 0 0 1 .2-1l1.6-1.4a.8.8 0 0 1 1.2.1c1.7 2.6 3.5 5 5.2 7.3l12.4 16.8a.8.8 0 0 0 1.1.2l23.6-38.5 2.5-4.2a.8.8 0 0 0-1-1.1z"
                fill="#65bd60"
              />
            </g>
          </g>
        </svg>
      </a>

      <div className={styles.Col} data-testid="city-name">
        <div className={classNames(styles.CityName)}>{cityName}</div>
      </div>

      <div className={classNames(styles.MainNav, styles.Col)}>
        {MAIN_NAV.map(([text, url]) => (
          <a suppressHydrationWarning key={text} href={url} className={classNames(styles.NavLink, 'transition-color')} rel="noopener noreferrer">
            {text}
          </a>
        ))}
      </div>

      {/** TODO: get rid of these portals */}
      <div className={classNames(styles.NavRight, styles.Col)}>
        {portals && (
          <>
            <div className="portal" id={portals.landingPageButton} />
            <div className="portal" id={portals.cartButton} />
            <div className="portal" id={portals.authButton} />
          </>
        )}
      </div>
    </nav>
    <div id={portals.skipToMain} className={styles.SkipToMain} />
    <TicketsButton />
  </>
)
